import { Link } from 'react-router-dom';
import { Building2, Monitor, Presentation, Users, Video } from 'lucide-react';

export function LandingAudienceSection() {
  return (
    <section className="cf-section cf-audience-section" id="for-whom">
      <div className="cf-section-head">
        <h2>Для кого подходит</h2>
        <p>Для команд и мероприятий, где каждая минута влияет на расписание, качество эфира и впечатление аудитории.</p>
      </div>
      <div className="cf-audience-grid">
        <Link
          to="/use-cases/conferences"
          className="cf-card cf-audience-card cf-audience-card-link"
          id="for-whom-conferences"
        >
          <span className="cf-feature-icon" aria-hidden="true">
            <Users size={22} strokeWidth={2} />
          </span>
          <h3>Конференции</h3>
        </Link>
        <Link
          to="/use-cases/presentations"
          className="cf-card cf-audience-card cf-audience-card-link"
          id="for-whom-presentations"
        >
          <span className="cf-feature-icon" aria-hidden="true">
            <Presentation size={22} strokeWidth={2} />
          </span>
          <h3>Презентации и доклады</h3>
        </Link>
        <article className="cf-card cf-audience-card" id="for-whom-production">
          <span className="cf-feature-icon" aria-hidden="true">
            <Video size={22} strokeWidth={2} />
          </span>
          <h3>Продакшн-команды</h3>
        </article>
        <article className="cf-card cf-audience-card" id="for-whom-corporate">
          <span className="cf-feature-icon" aria-hidden="true">
            <Building2 size={22} strokeWidth={2} />
          </span>
          <h3>Корпоративные ивенты</h3>
        </article>
        <article className="cf-card cf-audience-card" id="for-whom-webinars">
          <span className="cf-feature-icon" aria-hidden="true">
            <Monitor size={22} strokeWidth={2} />
          </span>
          <h3>Вебинары и онлайн-мероприятия</h3>
        </article>
      </div>
    </section>
  );
}
